import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${':jobId' | `${number}`}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}`;
